import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Card, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useIsMounted from '../../hooks/useIsMounted.jsx';
import './CookiesInfluencer.scss';

function CookiesInfluencer() {
  const [policies, setPolicies] = useState(null);
  const [loading, setLoading] = useState(true);
  const isMountedComponent = useIsMounted();
  const { t } = useTranslation();

  useEffect(() => {
    axios.get('/api/v1/static/cookies_influencer')
      .then(({ data }) => {
        if (isMountedComponent) {
          const [content] = $(data).find('section .container');
          if (content) {
            setPolicies(content.innerHTML);
          }
        }
      }).finally(() => {
        if (isMountedComponent) {
          setLoading(false);
        }
      });
  }, []);

  return <Container id="CookiesInfluencer">
    {loading ?
      <Card className="empty mt-2">
        {t('influencers.common.loading')}...
      </Card> :
      <span dangerouslySetInnerHTML={{ __html: policies }} />
    }
  </Container>;
}

export default CookiesInfluencer;